import { emptyError } from "../../../Types/ServicesType/servicesType";
import api from "@services/apiList";
import instance from "@services/services";
const {reportsApi}=api
export const departmentWiseReportSearchService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.departmentWiseReport,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const departmentWiseReportSearchpdfService= async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.departmentwiseReportPdf,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
